export const curatedImageSequence = [
  "flatlayImages",
  "ecomVideos",
  "flatlayImages",
  "campaignImages",
  "ecomImages",
  "flatlayImages",
  "ecomCloseUpImages",
  "flatlayImages",
  "flatlayImages",
  "ecomVideos",
  "ecomImages",
  "flatlayImages",
  "ecomImages",
  "flatlayImages",
];

// Campaign-first imagery: tag products in Shopify with `productTag` (Libre pattern).
// `handle` is the collection handle for collection-page overrides.
const CAMPAIGN_FIRST_COLLECTIONS = [
  {
    handle: "the-libre-collection",
    productTag: "the libre collection",
  },
  {
    handle: "still-heat",
    productTag: "still heat",
  },
];

const CAMPAIGN_FIRST_PRODUCT_TAGS = CAMPAIGN_FIRST_COLLECTIONS.map(
  ({ productTag }) => productTag
);

const CAMPAIGN_FIRST_COLLECTION_HANDLES = CAMPAIGN_FIRST_COLLECTIONS.map(
  ({ handle }) => handle
);

// Optional one-off product handle overrides without tagging.
const CAMPAIGN_FIRST_PRODUCT_HANDLES = [];

const FILTER_VALUE_LABELS = {
  Default: "One Size",
  OS: "One Size",
};

export function getFilterValueLabel(label) {
  if (label == null) {
    return label;
  }

  return FILTER_VALUE_LABELS[label] ?? label;
}

export function collectionUsesCampaignFirstImages(collectionHandle) {
  const normalizedHandle = collectionHandle?.toLowerCase().trim();

  return (
    !!normalizedHandle &&
    CAMPAIGN_FIRST_COLLECTION_HANDLES.includes(normalizedHandle)
  );
}

export function productUsesCampaignFirstImages(
  product,
  { collectionHandle = null } = {}
) {
  if (collectionUsesCampaignFirstImages(collectionHandle)) {
    return true;
  }

  const handle = product?.handle?.toLowerCase().trim();

  if (
    handle &&
    CAMPAIGN_FIRST_PRODUCT_HANDLES.some(
      (campaignHandle) => campaignHandle === handle
    )
  ) {
    return true;
  }

  return product?.tags?.some((tag) =>
    CAMPAIGN_FIRST_PRODUCT_TAGS.includes(tag.toLowerCase().trim())
  );
}
